import { useState, useRef, useCallback, useMemo } from 'react'
import { Blurhash } from 'react-blurhash'
import { isBlurhashValid } from 'blurhash'
import { useInViewPort } from '../useInViewPort'

type HookProps = {
  ratio?: number
  blurHash?: string | null
  isLocalFile?: boolean
}

const useLazyMedia = ({ blurHash, ratio, isLocalFile }: HookProps) => {
  const [isLoaded, setIsLoaded] = useState(!!isLocalFile)

  const wrapperRef = useRef<HTMLDivElement>(null)
  const { isVisible: isOnScreen } = useInViewPort(wrapperRef)

  const onLoad = useCallback(() => {
    setIsLoaded(true)
  }, [])

  const isModalSlider =
    wrapperRef.current && wrapperRef.current.closest('div[role="dialog"]')

  const placeholder = useMemo(() => {
    if (isLoaded || !blurHash || !isBlurhashValid(blurHash)) return null

    return (
      <Blurhash
        className="!block h-full !w-auto [&>*]:rounded-md"
        style={ratio ? { aspectRatio: `${ratio}` } : undefined}
        hash={blurHash}
        width={'100%'}
        height={'100%'}
        resolutionX={32}
        resolutionY={32}
        punch={1}
      />
    )
  }, [isLoaded, blurHash, ratio])

  const canShow = !!(isOnScreen || isModalSlider)

  return {
    onLoad,
    isLoaded,
    isOnScreen: canShow,
    wrapperRef,
    placeholder,
  }
}

export default useLazyMedia
